import request from "../Config/axios";
// -----------------------------------------------------------
export const GetById_Factor_Api = async (id) => {
    const { data } = await request.get(
        `/Factor/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
export const GetByReserveId_Factor_Api = async (reserveId) => {
    const { data } = await request.get(
        `/Factor/GetByReserveId/?reserveId=${reserveId}`
    );
    return data;
};
// -----------------------------------------------------------
export const CalcFactor_Factor_Api = async (reserveId) => {
    const { data } = await request.get(
        `/Factor/CalcFactor/?reserveId=${reserveId}`
    );
    return data;
};
// -----------------------------------------------------------